import React              from 'react';
import { BrowserRouter, Route, Switch} from 'react-router-dom';
// import CurrentUserStore   from './stores/CurrentUserStore';
import NotFoundPage from './pages/NotFoundPage';
import 'typeface-roboto';


import LoginPage from './pages/LoginPage';
import MainPage from './pages/MainPage';


class App extends React.Component {

  constructor(props) {
    super(props);

    this.onUserChange = this.onUserChange.bind(this);

    this.state = {
      currentUser: {}
    };
  }

  onUserChange(err, user) {
    if ( err ) {
      this.setState({ error: err });
    } else {
      this.setState({ currentUser: user || {}, error: null });
    }
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  render() {
    return(
      <BrowserRouter>
        <div>
          <Switch>
              <Route path="/login" component={LoginPage} />
              <Route path="/" component={MainPage} />
              <Route component={NotFoundPage} />
          </Switch>
        </div>
      </BrowserRouter>);
  }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.js